import * as React from 'react';
import { Container } from 'ui';
import LoadingComponent from '@tock/shared/components/LoadingComponent';
import ProfileSectionTitle from 'components/profile/ProfileSectionTitle';
import clsx from 'clsx';

interface Props {
  name: string | JSX.Element;
  action?: JSX.Element;
  sectionStyle?: string;
  wrapperStyle?: string;
  isLoading: boolean;
  children: React.ReactNode;
}

/**
 * Generic section component for sections of the profile page.
 */
const ProfileSection = ({
  name,
  sectionStyle,
  wrapperStyle,
  isLoading,
  children,
  action,
}: Props) => {
  const style = clsx(sectionStyle, 'ProfileOverview--section');
  return (
    <div className={style}>
      <Container className={wrapperStyle}>
        <LoadingComponent isLoading={isLoading}>
          <ProfileSectionTitle name={name} action={action} />
          {children}
        </LoadingComponent>
      </Container>
    </div>
  );
};

export default ProfileSection;
